import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * getTableSorts helper.
 *
 * @author Mikhail Siutsou
 * @function getTableSorts
 * @category helpers
 * @param {TableState['sorts']} sort array
 * @return {{ [key: string]:'ASC' | 'DESC' } | undefined} sort api object.
 */
export var getTableSorts = function getTableSorts(sort) {
  if (!sort) return undefined;
  return sort.reduce(function (acc, item) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, item.id, item.desc ? 'DESC' : 'ASC'));
  }, {});
};